import type { PhoneNumber } from "libphonenumber-js";

import type { FormCollectionInput } from "../../core/data-forms/form-input-types";
import type { UrlLink } from "../BaseUrl";

export type InitialOnboarding = {
  distributorConfigurationCode?: string;
  email: string;
  phoneNumber?: PhoneNumber;
  firstName: string;
  lastName: string;
  termsAcceptance: boolean;
  privacyPolicyAcceptance?: boolean;
};

export enum OnboardingStatus {
  INITIATED = "INITIATED",
  COMPLETION_PENDING = "COMPLETION_PENDING",
  READY_TO_SUBMIT = "READY_TO_SUBMIT",
  SUBMITTED = "SUBMITTED",
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
  EXTERNAL_CHECK_PENDING = "EXTERNAL_CHECK_PENDING",
}

export const MUST_RETAKE_ONBOARDING_FILE_STATUSES = [
  OnboardingStatus.INITIATED,
  OnboardingStatus.READY_TO_SUBMIT,
  OnboardingStatus.COMPLETION_PENDING,
];

export interface OnboardingFile {
  status: OnboardingStatus;
  links?: UrlLink[];
  termsAndConditionsUrl?: string;
  form: FormCollectionInput & {
    inputs: FormCollectionInput[];
  };
}

export type OnboardingSubmitConfig = {
  forWeb?: boolean;
};

/** Ce que le back sait d'un document déjà envoyé. Son `name` est le libellé du champ, pas
 * le nom du fichier d'origine : celui-là n'est jamais transmis, on poste du base64 nu. */
export interface OnboardingDocument {
  id: string;
  type: string;
  name: string;
  status: string;
  uploadDate: string;
}
